
import { PunkParsedInitData } from "../../../server/data/PunkParsedInitData";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { ReelGraphicBackground } from "../../independent/background/ReelGraphicBackground";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { PunkBackground } from "../../../background/PunkBackground";
import { PosterManager, PosterStates } from "../../independent/Poster/PosterManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { ReelItemOverlay, ReelOverlayState } from "../../independent/overlay/ReelItemOverlay";
import { TimelineLite, TweenLite } from "gsap";
import { JumpingWildController, JumpWildState } from "../../independent/jumpingWild/JumpingWildController";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { TrainState } from "../../independent/countup/XWaysCounter";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { ReelSymbolSize, PunkSymbolData } from "../../../punkEngine/config/PunkSymbolData";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";
import { IExpandAnimateConfig } from "../../../punkEngine/PunkEnginePlayer";

class RestoreState extends StateHandler{
    public static readonly START:string = "start";
    public static readonly EXPAND:string = "expand";
    public static readonly REVEAL:string = "reveal";
    public static readonly INTRO:string = "intro";
    public static readonly INTRO2:string = "intro2";
    public static readonly INTRO3:string = "intro3";
    public static readonly TRAIN:string = "train";
    public static readonly DONE:string = "done";
    public static readonly BUTTON:string = "button";
}

export class RestorePresentation extends Presentation {

    protected state:RestoreState = new RestoreState(RestoreState.DONE);
    protected scatterPositions:number[];

    protected scatterAmount:number = 0;
    protected wildPositions:number[];
    protected mysteryPos:number[];
    protected expanding: IExpandAnimateConfig[] = [];

    protected mysterySym:string = "";
    protected totalWin:number = 0;

    protected isBonus:boolean = false;
    protected isRespin:boolean = false;
    protected isIntro:boolean = false;
    protected areaSize:number[];

    protected _fsLeft:number = 0;

    public setParsedInitData(data:PunkParsedInitData):void{
        this.PresentationState.set(PresentationState.ACTIVATED);
        this.scatterPositions = data.scatterReelPositions;
        this.mysterySym = data.mysterySym;
        this.isBonus = data.nextMode == GameMode.FREESPIN;
        this.isRespin = data.nextMode == GameMode.RESPIN;
        this.state.set(RestoreState.START);
        if(data.freespinsLeft > 0)
            this._fsLeft = data.freespinsLeft;
        
        for(let s:number = 0; s < this.scatterPositions.length;s++) if(this.scatterPositions[s] >= 0 && this.scatterPositions[s] <= 2) this.scatterAmount++;

        if(this.scatterAmount > 0) this.isIntro = true;

        this.wildPositions = data.wildReelPositions;
        this.mysteryPos = data.mysteryReelPositions;
        this.totalWin = data.totalWin;

        this.areaSize = data.gameAreaSize;
        this.expanding = [];

        for (let reel = 0; reel < this.mysteryPos.length; reel++) {
            if(reel == 5) continue;
            if (this.mysteryPos[reel] == -1) continue;
            const expandConfig: IExpandAnimateConfig = {
                toSize: ReelSymbolSize.FOUR + ((data.gameAreaSize[reel]-3)),
                reelID: [reel],
                symbolID: this.mysteryPos[reel],
                duration: 0.4,
            }
            this.expanding.push(expandConfig);
        }
    }

    public preStart():void{
        if(this._fsLeft > 0){
            PunkGameModuleConfig.xWayCounter.UpdateFreeSpinCounter(this._fsLeft)
            SlotGame.keypad.setZeroBetSpinCounter(this._fsLeft);
        }
        SlotGame.keypad.hide();
    }
    
    public getPresentation(){
        switch(this.state.state){
            case RestoreState.START:
                SoundManager.reset();
                PunkEngineManager.RAll((Reel:number) => ReelSlicedDivider.instance.addDividers(false,Reel));
                if(this.isIntro) ReelAnimationManager.bonusReel.NumberOfSkulls(this.scatterAmount);
                this.pTimeline.to(this,0.4,{});
                this.state.set(RestoreState.INTRO);
                if(this.totalWin > 0) SlotGame.keypad.setWin(this.totalWin, true, PunkGameModuleConfig.featurePrice.isWinBelowStake());
                this.expandMysteries();
                break;
            case RestoreState.REVEAL:
                this.revealing();
                this.state.set(RestoreState.INTRO);
                break;
            case RestoreState.INTRO:
                if(this.isIntro) this.showBonuHits();
                else this.bonusReelBoom();
                this.ReelBoom();
                this.state.set(this.isRespin ? RestoreState.INTRO2 : RestoreState.TRAIN);
                break;
            case RestoreState.INTRO2: // RESPIN
                this.SwitchSymbol();
                this.state.set(RestoreState.INTRO3)
                break;
            case RestoreState.INTRO3:
                this.pTimeline.add(PunkBackground.instance.changeGraphicAlpha(0.3, 0.4),0);
                this.transformAndChain();
                this.state.set(RestoreState.DONE);
                break;
            case RestoreState.TRAIN: // FS
                if(this.isIntro)this.trainArrives();
                this.state.set(this.isIntro ? RestoreState.BUTTON : RestoreState.DONE)
                break;
            case RestoreState.BUTTON: 
                this.buttonScreen();
                break;
            default:
                this.PresentationState.set(PresentationState.END);
                break;
        }
    }

    public endPresentation():void{
        SlotGame.keypad.show();
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    protected revealing(): void {
        const isMultiSize: boolean = !!PunkSymbolData.getSymbolConfig(this.mysterySym).MULTISIZE;

        this.pTimeline.to(this,0.45,{});

        for (let j = 0; j < this.expanding.length; j++) {
            let symbol: PunkSymbol = PunkEngineManager.getReel(this.expanding[j].reelID![0]).getSymbol(this.expanding[j].symbolID!)!;
            const expandConfig: IExpandAnimateConfig = {
                toSize: this.expanding[j].toSize,
                reelID: this.expanding[j].reelID,
                symbolID: this.expanding[j].symbolID,
                updateSize: PunkSymbolData.isMultiSymbolExpanding(this.mysterySym),
                duration: 0,
            }
            
            if (!isMultiSize) {
                StateSymbolWin.instance.HideMulti({
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.IDLE,
                });
            } else{
                StateSymbolWin.instance.DropMulti({
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.IDLE,
                    duration: 0.4
                });
            } 

            StateSymbolWin.instance.playFrameAnimation({
                ReelID: expandConfig.reelID![0],
                SymID: expandConfig.symbolID!,
                State: ReelSymbolStates.REVEAL,
                duration: 0.45
            });
           
            StateSymbolWin.instance.playSymbolAnimation({
                ReelID: expandConfig.reelID![0],
                SymID: expandConfig.symbolID!,
                State: ReelSymbolStates.REVEAL,
                followSymbol:true,
                showSymbol: true,
                duration: 0.45
            });

            symbol.changeSymbol(this.mysterySym),
            PunkEngineManager.onExpandSymbol(expandConfig)

            for (let row: number = 0; row < PunkEngineManager.getReel(expandConfig.reelID![0]).AllSymbols.length; row++) {
                const smyID:number = PunkEngineManager.getReel(expandConfig.reelID![0]).AllSymbols[row].posID;
                PunkEngineManager.getReel(expandConfig.reelID![0]).getSymbol(smyID)!.playBg();
            }
            // for (let row: number = 0; row < PunkEngineManager.getReel(expandConfig.reelID![0]).AllSymbols.length; row++) {
            //     PunkEngineManager.getReel(expandConfig.reelID![0]).getSymbol(row)!.playBg();
            // }
            ReelSlicedDivider.instance.addDividers(false,expandConfig.reelID![0]);
            // PunkEngineManager.getReel(expandConfig.reelID![0]).addDividers();
        }

        SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_EXPAND_NO_WIN);
    }

    protected expandMysteries():void{
        const expandTime:number = 0.3;

        for(let i = 0; i < this.expanding.length; i++){

            const expandConfig: IExpandAnimateConfig = this.expanding[i];
            const reelID:number = expandConfig.reelID![0];

            PunkEngineManager.onExpandSymbol(expandConfig);
            let size: number = expandConfig.toSize - ReelSymbolSize.FOUR;
            let sizeCounter: string = (size + 1).toString();
            
            StateSymbolWin.instance.playMultiplyAnimation({
                value: sizeCounter,
                ReelID: reelID,
                SymID: expandConfig.symbolID!,
                duration: expandTime,
                State: ReelSymbolStates.NORMAL,
            });

            // PunkGameModuleConfig.xWayCounter.setValue(undefined, this._expandingMultiplyValues[reelID], expandTime);
            for (let row: number = 0; row < PunkEngineManager.getReel(reelID).windowAmount; row++) {
                PunkEngineManager.getReel(reelID).getSymbol(row)!.changeSizeBg(expandTime);
                // ReelSlicedDivider.instance.changeSizeBg(reelID, expandTime);s
                ReelItemOverlay.instance.changeSizeBg(reelID,row,expandTime);
            }
        }
        
        this.pTimeline.to(this,expandTime,{});
        
        if(this.expanding.length > 0) this.state.set(RestoreState.REVEAL);
    }

    protected trainArrives():void{
        PunkGameModuleConfig.xWayCounter.setTrainItems(["X25","SPIN1","MFS","WJ","FULL","X1"])

        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.setVisible(false,0.2), 0);
        this.pTimeline.add(() => JumpingWildController.instance.ChangeToSpine(),this.pTimeline.totalDuration() + 0.2);
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.INTRO),this.pTimeline.totalDuration() + 0.2);
        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_BRAKE));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OPEN_CLOSE),this.pTimeline.totalDuration() +  TrainState.getDuration(TrainState.INTRO));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.showTrainItems(true, [0,1,2,3,4,5], 0.3),this.pTimeline.totalDuration() +  TrainState.getDuration(TrainState.OPEN_CLOSE)-0.15);
        this.pTimeline.to(this,0.3,{});
        this.pTimeline.add(() =>  PosterManager.instance.playSirene(false));
        this.pTimeline.add(() =>  PunkGameModuleConfig.xWayCounter.counterActive(false));
    }

    protected SwitchSymbol():void{
        let jwIndx:number = 0;
        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),0);
        for(let reel = 0; reel < this.scatterPositions.length; reel++){
            if(this.scatterPositions[reel] == -1) continue;
            
            this.pTimeline.add(JumpingWildController.instance.JumpTo({
                ID: jwIndx,
                to:{reel: reel, row: this.scatterPositions[reel]},
                duration:0.6,
                state: JumpWildState.WIN
            }),0)
            jwIndx++;

            this.pTimeline.add([
                () => JumpingWildController.instance.HideSkulls(0.6),
                () => StateSymbolWin.instance.playFrameAnimation({
                    ReelID: reel,
                    SymID: this.scatterPositions[reel],
                    State:ReelSymbolStates.TRANSFORM,
                    duration: 0.6,
                }),
                () => PunkEngineManager.getReel(reel).getSymbol(this.scatterPositions[reel])!.changeState({
                    state: ReelSymbolStates.TRANSFORM,
                    duration: 0.6,
                    newSym: "W"
                }),
            ],0.6);
        }
    }
    
    protected transformAndChain():void{
        const transformDurr:number = MathHelper.frameToSeconds(15);
        let startTime:number = this.pTimeline.totalDuration();
        let transformDelay:number = startTime;
        const tl:TimelineLite = new TimelineLite();

        playExpandingFromArray(this.scatterPositions);
        playExpandingFromArray(this.wildPositions);

        this.pTimeline.add(tl);

        startTime = this.pTimeline.totalDuration()-transformDurr*0.5;
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length-1;reel++){
            if(!PunkEngineManager.getReel(reel).isActive){
                this.pTimeline.add(ReelAnimationManager.getReelArea(reel).chainsActive(true), startTime);
                this.pTimeline.add( () => SoundManager.playSoundEffect([SoundConfig.instance.CHAIN1,SoundConfig.instance.CHAIN2][reel%2]), startTime)
                startTime += 0.3;
            }
        }

        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.setValue(undefined, Math.pow(3,6),0.5));
        function playExpandingFromArray(arr:number[]):void {
            for(let reel:number = 0; reel < arr.length;reel++){
                if(arr[reel] >= 0 && arr[reel] <= 2) PunkEngineManager.getReel(reel).isActive = false;

                transformDelay = startTime;
                const firstSymbol:PunkSymbol = PunkEngineManager.getReel(reel).getSymbol(arr[reel])!;
                if(firstSymbol.isWild) firstSymbol.setActive(true);
                
                for(let row:number = arr[reel]-1; row >= 0 ; row --){
                    if(row > 2) break;
                    const symbol:PunkSymbol = PunkEngineManager.getReel(reel).getSymbol(row)!;
                    symbol.setActive(true);
                    if(symbol.isWild) continue;
                    tl.add(symbol.changeState({
                        state: ReelSymbolStates.TRANSFORM,
                        forceState:true,
                        newSym: ReelSymbolName.WILD,
                        duration: transformDurr
                    }),transformDelay);
                    tl.add(ReelItemOverlay.instance.playAnimation(reel,row+1,ReelOverlayState.IGNITE),transformDelay);
                    tl.add(ReelItemOverlay.instance.playAnimation(reel,row,ReelOverlayState.FIRE),transformDelay + MathHelper.frameToSeconds(5));
                    transformDelay += MathHelper.frameToSeconds(10);
                }
                if(arr[reel]-1 >= 0){
                    startTime += 0.1;
                }
            }
        }
    }

    protected showBonuHits():void{
        let delay:number = 0;
        const nextAnim:number = 0.05;

        SoundManager.playSoundEffect(SoundConfig.instance.BLACK_SWIPE);
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length-1;reel++){
            if(this.scatterPositions[reel] >= 0){
                this.pTimeline.add([
                    StateSymbolWin.instance.playFrameAnimation({
                        ReelID: reel,
                        SymID: this.scatterPositions[reel],
                        State:ReelSymbolStates.TRANSFORM,
                        duration: 0.6,
                    }),
                    () => PunkEngineManager.getReel(reel).getSymbol(this.scatterPositions[reel])!.changeState({ state: ReelSymbolStates.IDLE }),
                ],delay)
            }
            for(let row:number = 0; row < PunkEngineManager.getReel(reel).AllWindowSymbols.length;row++){
                const symPos:number = PunkEngineManager.getReel(reel).AllWindowSymbols[row].posID;
                this.pTimeline.add(() => PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(1,0),delay)
                this.pTimeline.add(() => PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0,0.5),delay+nextAnim)
            }
            delay += nextAnim;
        }
      
        this.bonusReelBoom(delay);
    }

    protected bonusReelBoom(startdelay:number = 0):void{
        this.pTimeline.add([
            AnimationEffects.Shake({
            x:0.4,
            y:1,
            obj: ReelAnimationManager.bonusReel,
            duration:1,
            Intensity:6,
            positionCb: () => { 
                const posOffsetY:PIXI.Point = MathHelper.pointAdd(<PIXI.Point>PunkEngineManager.getReel(5).position, new PIXI.Point(0,PunkEngineManager.dim.scale.y * PunkSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT));
                return posOffsetY;
             },
            hertz:100
            }),
            () => SoundManager.playSoundEffect(SoundConfig.instance.FENCE_EXPLODE),
        ],startdelay);

        this.pTimeline.add([
            () => ReelAnimationManager.bonusReel.killLoop(),
            () => ReelAnimationManager.bonusReel.playBoom(),
        ],"-=" + 0.25);
        const boomReelID:number = ReelAnimationManager.bonusReel.ReelID;
        for(let row = 0; row < PunkEngineManager.getReel(boomReelID).AllSymbols.length; row++){
            this.pTimeline.add(() => PunkEngineManager.getReel(boomReelID).AllSymbols[row].setSuperVisibility(false));
        }
        this.pTimeline.to(this,0.5,{});
    }

    protected ReelBoom():void{
        if(this.isRespin){
            // this.pTimeline.add([
            //     PosterManager.instance.playPoster(PosterStates.RESPIN),
            //     () => SoundManager.playSoundEffect(SoundConfig.instance.RESPIN_INTRO),
            // ]);
        }else if(this.isIntro){
            this.pTimeline.add([
                PosterManager.instance.playPoster(this.scatterAmount == 3 ? PosterStates.BONUS : PosterStates.BONUS2),
                () => SoundManager.playSoundEffect(SoundConfig.instance.FS_INTRO),
                () =>  PosterManager.instance.playSirene(true, 0),
            ]);
        }
        if(this.isRespin)this.pTimeline.add(() => SoundManager.playRespin());
        if(this.scatterPositions.length > 0){
            for(let reel = 0; reel < this.scatterPositions.length; reel++){
                if(this.scatterPositions[reel] == -1) continue;
                JumpingWildController.instance.createJumpWilds(reel, 0);
            }
            this.pTimeline.add([
                () => ReelAnimationManager.bonusReel.removeSkulls(false),
                () => JumpingWildController.instance.StartShow()
            ]);
        }

        this.pTimeline.add(() => ReelAnimationManager.bonusReel.setActiveReel(true))
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.setValue(undefined, Math.pow(3,6), 0.5))
        this.pTimeline.to(this,0.2,{});
    }

    protected buttonScreen():void{
        this.pTimeline.fromTo(ReelGraphicBackground.instance,0.3,{alpha:0 },{alpha:0.45});
        PunkBackground.instance.changeGraphicAlpha(0.3, 0.6);
        this.pTimeline.add(SplashController.instance.Play());
    }

    public skipPresentation():void{
        if(this.state.equal(RestoreState.BUTTON)){
            this.state.set(RestoreState.DONE);
            SplashController.instance.stop();
            SoundManager.playBonus();
            SoundManager.fadeAmbienceLoop(1,1);
            SlotGame.keypad.setZeroBetSpinCounter(7);
            PunkGameModuleConfig.xWayCounter.UpdateFreeSpinCounter(7)
            TweenLite.fromTo(ReelGraphicBackground.instance,0.3,{alpha:0.45 },{alpha:0});
            this.pTimeline.totalProgress(1);
        } 
    }
}

